'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from '@/components/ui/dialog';
import { AnniversaryForm } from './anniversary-form';
import { Heart } from 'lucide-react';

export function AddAnniversary() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button>
          <Heart className="mr-2 h-4 w-4" />
          Add Anniversary
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add a New Anniversary</DialogTitle>
          <DialogDescription>
            Enter the details below to add a new anniversary to your calendar.
          </DialogDescription>
        </DialogHeader>
        <AnniversaryForm onSuccess={() => setIsOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}
